import React from 'react';
import Socials from './../Shared/socials';

function Footer(){
  return(
    <footer className="text-center">
      <Socials />
      <p>&copy; Ocean and Dexter's Kitchen</p>
    </footer>
  )
}

export default Footer;